import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-management"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "search-and-buttons"
};
const _hoisted_4 = ["onClick"];
import { ref, onMounted } from 'vue';
// 引入图标plus
import { Plus } from '@element-plus/icons-vue';
import api from '@/server/request/api';
import add from './add.vue';
import { ElMessage } from "element-plus";
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const bg = {
      backgroundColor: '#f8fafc'
    };
    const addRef = ref();
    onMounted(() => {
      getUserList();
    });
    const search = ref('');
    const userData = ref([]);
    const ids = ref([]);
    const editUser = user => {
      // Logic to edit user
      if (addRef.value) {
        const userCopy = JSON.parse(JSON.stringify(user)); // Deep copy the user object
        addRef.value.openDialog(userCopy);
      }
    };
    const deleteUser = user => {
      let ids = {
        ids: user.id
      };
      api.deleteUser(ids).then(res => {
        if (res.code === 200) {
          ElMessage.success('删除成功');
          getUserList();
        } else {
          ElMessage.error(res.msg);
        }
      });
      // Logic to delete user
    };
    const handleSelectionChange = selection => {
      ids.value = selection.map(item => item.id);
    };
    // 获取用户列表
    const getUserList = async () => {
      const params = {
        username: search.value
      };
      const res = await api.getUserList(params);
      if (res.code === 200) {
        userData.value = res.result;
      } else {
        ElMessage.error(res.msg);
      }
    };
    const addUser = () => {
      console.log(addRef.value);
      addRef.value.openDialog();
    };
    // 导出数据
    // 导出数据
    const exportData = async () => {
      if (ids.value.length === 0) {
        ElMessage.warning('请先选择用户进行导出');
        return;
      }
      try {
        // 调用导出接口
        const res = await api.exportData({
          ids: ids.value.join(',')
        });
        // 检查返回数据是否为空
        if (!res || res.size === 0) {
          ElMessage.error('导出失败，返回的数据为空');
          return;
        }
        // 确保返回的是 Blob 或流数据
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        // 检查 Blob 是否有效
        if (blob.size === 0) {
          ElMessage.error('导出失败，生成的文件为空');
          return;
        }
        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `user_data_${Date.now()}.xlsx`); // 动态设置文件名
        document.body.appendChild(link);
        link.click();
        // 清理下载链接
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        // 显示成功消息
        ElMessage.success('数据导出成功');
      } catch (error) {
        // 捕获错误并提示
        console.error('导出失败:', error);
        ElMessage.error('导出失败，请重试');
      }
    };
    const changeStatus = user => {
      api.editUser({
        id: user.id,
        status: user.status
      }).then(res => {
        if (res.code === 200) {
          ElMessage.success('修改成功');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    // 批量删除
    const batchDelete = () => {
      api.deleteUser({
        ids: ids.value.join(',')
      }).then(res => {
        if (res.code === 200) {
          ElMessage.success('删除成功');
          getUserList();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    // 将时间戳转为YYYY-MM-DD HH:MM:SS
    const formatTime = time => {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(add, {
        ref_key: "addRef",
        ref: addRef,
        onUserUpdated: getUserList
      }, null, 512), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "header"
      }, [_createElementVNode("div", {
        class: "title"
      }, "用户管理")], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        onChange: getUserList,
        style: {
          "width": "240px"
        },
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
        placeholder: "用户名搜索",
        clearable: "",
        class: "username-search"
      }, {
        suffix: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-input__icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(search))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "btn",
        type: "primary",
        onClick: addUser
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }), _cache[2] || (_cache[2] = _createTextVNode(" 新增用户 ", -1))]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "btn",
        type: "danger",
        onClick: batchDelete
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("批量删除", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "btn",
        onClick: exportData
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("导出数据", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        style: {
          "position": "absolute",
          "right": "40px"
        },
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/home'))
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("返回", -1)]))]),
        _: 1
      })]), _createVNode(_component_el_table, {
        data: userData.value,
        style: {
          "width": "100%"
        },
        "header-cell-style": bg,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "username",
          label: "用户名"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", {
            style: {
              "cursor": "pointer",
              "color": "#4f5cdb",
              "text-decoration": "underline"
            },
            onClick: $event => _unref(router).push(`/user/edit/${scope.row.id}`)
          }, _toDisplayString(scope.row.username), 9, _hoisted_4)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "system",
          label: "角色"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.system ? '管理员' : '普通用户'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "dept",
          label: "部门"
        }), _createVNode(_component_el_table_column, {
          prop: "cratedTime",
          label: "创建时间"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(formatTime(scope.row.cratedTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            class: "ml-2",
            onChange: $event => changeStatus(scope.row),
            style: {
              "--el-switch-on-color": "#13ce66",
              "--el-switch-off-color": "#ff4949"
            }
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            onClick: $event => editUser(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            onClick: $event => deleteUser(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])]);
    };
  }
});